import routesAccount from './routesAccount'
import routesServices from './routesServices'
import routesPayment from './routesPayment'
import routesStatic from './routesStatic'

import {
  EMPLOYER,
  PARTNER,
  EMPLOYEE,
  MODERATOR,
  AGENT,
} from '@/constants/usersTypes'
import formatRoutesPaths from './common/formatRoutesPaths'

const Account = () => import(/* webpackChunkName: "account-page" */ '../views/Account')
const AboutPage = () => import(/* webpackChunkName: "about-page" */ '../views/AboutPage')

const E404 = () => import(/* webpackChunkName: "e404-page" */ '../views/E404')
const SignIn = () => import(/* webpackChunkName: "sign-in-page" */ '../views/SignIn')
const RegisterCandidatePage = () => import('../views/RegisterCandidatePage');
const AuthPage = () => import(/* webpackChunkName: "auth-page" */ '../views/AuthPage')
const AuthPageModerator = () => import(/* webpackChunkName: "auth-page" */ '../views/AuthPageModerator')
const AuthSecondaryPage = () => import(/* webpackChunkName: "auth-page" */ '../views/AuthSecondaryPage')
const HomePage = () => import(/* webpackChunkName: "home-page" */ '../views/HomePage')
const ResumeSharedPage = () => import('../views/ResumeSharedPage')
const VacanciesPage = () => import(/* webpackChunkName: "vacancies-page" */ '../views/VacanciesPage')
// const EmployerProfilePage = () => import(/* webpackChunkName: "employer-profile-page" */ '../views/EmployerProfilePage')
// const VacancyCardPage = () => import(/* webpackChunkName: "vacancy-card-page" */ "../views/VacancyCardPage");
// --
const VacancyPage = () => import(/* webpackChunkName: "vacancy-page2" */ '../views/Vacancy')
// --
const TextPage = () => import(/* webpackChunkName: "text-page" */ '../views/TextPage')

const NewsPage = () => import(/* webpackChunkName: "news-page" */ '../views/NewsPage')
const NewsSinglePage = () => import(/* webpackChunkName: "news-page" */ '../views/NewsSinglePage')
// const CompanyDossierPage = () => import(/* webpackChunkName: "company-dossier-page" */'../views/CompanyDossierPage')
const CreditsPage = () => import(/* webpackChunkName: "credits-page" */'../views/CreditsPage')
const CreditsGetPage = () => import(/* webpackChunkName: "credits-page" */'../views/CreditsGetPage')
const LegalServicesPage = () => import(/* webpackChunkName: "legal-services-page" */'../views/LegalServicesPage')
const LegalServicesHelpRequestSentPage = () => import(/* webpackChunkName: "legal-services-page" */'../views/LegalServicesHelpRequestSentPage')
const EmployersLTPage = () => import(/* webpackChunkName: "for-employers-lithuania-page" */'../views/EmployersLTPage')
const EmployerPolandPage = () => import(/* webpackChunkName: "for-employers-poland-page" */'../views/EmployerPolandPage')
const LublinPage = () => import(/* webpackChunkName: "lublin-page" */'../views/aboutCities/LublinPage')
const FindVacancyPage = () => import(/* webpackChunkName: "find-vacancy-page" */'../views/FindVacancyPage')
const FindVacancyQuestionnairePage = () => import(/* webpackChunkName: "find-vacancy-page" */'../views/FindVacancyQuestionnairePage')
// const CompanyProfilePage = () => import(/* webpackChunkName: "company-page" */ '../views/CompanyProfilePage')
const SiteMap = () => import(/* webpackChunkName: "site-map-page" */ '../views/SiteMap')
const WidgetTestPage = () => import(/* webpackChunkName: "site-widgets-page" */ '../views/WidgetTestPage')
const WidgetTestPage1 = () => import(/* webpackChunkName: "site-widgets-page" */ '../views/WidgetTestPage1')
const WidgetTestPage2 = () => import(/* webpackChunkName: "site-widgets-page" */ '../views/WidgetTestPage2')
const WidgetTestPage3 = () => import(/* webpackChunkName: "site-widgets-page" */ '../views/WidgetTestPage3')
const WidgetTestPage4 = () => import(/* webpackChunkName: "site-widgets-page" */ '../views/WidgetTestPage4')
const GuidePage = () => import(/* webpackChunkName: "guide-page" */ '../views/GuidePage')
const AdditionalQuestionsResponses = () => import('../views/AdditionalQuestionsResponses');

export default [
  {
    path: '',
    name: 'home',
    component: HomePage,
    meta: {
      footerUnderScreen: true,
    },
  }, {
    path: 'about',
    name: 'about',
    component: AboutPage
  }, {
    path: 'register',
    name: 'register-candidate',
    component: RegisterCandidatePage
  }, {
    path: 'sign-in',
    name: 'sign-in',
    component: AuthPage
  }, {
    path: 'sign-in-moderator',
    name: 'sign-in-moderator',
    component: AuthPageModerator
  }, {
    path: 'auth-partner',
    name: 'auth-partner',
    component: SignIn
  }, {
    path: 'auth/',
    name: 'auth',
    component: SignIn
  }, {
    path: 'auth-agent/',
    name: 'auth-agent',
    children: [
      {
        path: 'reset/',
        name: 'auth-agent-reset',
        // component: AuthSecondaryPage
      },
    ],
    component: AuthSecondaryPage
  }, {
    path: 'auth-employer/',
    name: 'auth-employer',
    component: AuthSecondaryPage
  }, {
    path: 'auth-employer/register',
    name: 'auth-employer-register',
    component: AuthSecondaryPage
  }, {
    path: 'shared-resume/:sharedResumeHash',
    name: 'shared-resume',
    component: ResumeSharedPage
  }, {
//   // VACANCY2
//   path: 'vacancies/v2/:vacancyId',
//   name: 'vacancy2',
//   component: VacancyPage2
// }, {
    // VACANCY
    path: 'vacancies/v/:vacancyId',
    name: 'vacancy',
    component: VacancyPage
  }, {
    // VACANCIES LIST WITH FILTERS & PARAMS
    path: 'vacancies/:professionsIds*/f/:staticFilters+/d/:dynamicFilters',
    name: 'vacancies-with-static&dynamic',
    component: VacanciesPage,
    meta: {
      footerUnderScreen: true,
    },
  }, {
    // VACANCIES LIST WITH PARAMS
    path: 'vacancies/:professionsIds*/d/:dynamicFilters',
    name: 'vacancies-with-dynamic',
    component: VacanciesPage,
    meta: {
      footerUnderScreen: true,
    },
  }, {
    // VACANCIES LIST WITH FILTERS
    path: 'vacancies/:professionsIds*/f/:staticFilters+',
    name: 'vacancies-with-static',
    component: VacanciesPage,
    meta: {
      footerUnderScreen: true,
    },
  }, {
    // REDIRECT EMPTY FILTERS
    path: 'vacancies/:professionsIds*/f',
    redirect: (to) => {
      return {
        name: 'vacancies',
        params: to.params,
        query: to.query,
      }
    }
  }, {
    path: 'vacancies/f',
    redirect: {name: 'vacancies'}
  }, {
    //VACANCIES LIST
    path: 'vacancies/:professionsIds*',
    name: 'vacancies',
    component: VacanciesPage,
    meta: {
      footerUnderScreen: true,
    },
    // }, {
    //   path: 'employers/:id',
    //   name: 'employer-profile',
    //   component: EmployerProfilePage
  }, {
    path: 'account',
    component: Account,
    children: formatRoutesPaths(routesAccount),
    meta: {
      requiresAuth: true,
      requiredUserTypes: [EMPLOYEE, PARTNER, EMPLOYER, MODERATOR, AGENT]
    }
  }, {
    path: 'news',
    name: 'news-page',
    component: NewsPage
  }, {
    path: 'news/:newsSlug',
    name: 'news-single-page',
    component: NewsSinglePage
  }, {
    path: 'privacy-policy',
    name: 'privacy-policy',
    component: TextPage,
    props: {textSlug: 'privacy-policy'}
  }, {
    path: 'terms-of-use',
    name: 'terms-of-use',
    component: TextPage,
    props: {textSlug: 'terms-of-use'}
  }, {
//   path: 'company/:companySlug',
//   name: 'company-info',
//   component: CompanyProfilePage
// }, {
//     path: 'company-info/:companySlug?',
//     name: 'company-info',
//     component: CompanyDossierPage
//   }, {
    path: 'site-map',
    name: 'site-map',
    component: SiteMap
  }, {
    path: 'widget/test',
    name: 'widget-test',
    component: WidgetTestPage
  },

  {
    path: 'services/finance/microcredit',
    name: 'credits',
    component: CreditsPage
  }, {
    path: 'services/finance/microcredit/get',
    name: 'credits-get',
    component: CreditsGetPage
  },

  {
    path: 'services/legal',
    name: 'legal-services',
    component: LegalServicesPage
  },
  {
    path: 'lithuania',
    name: 'employers-lt',
    component: EmployersLTPage,
    meta: {
      withoutHeader: true,
      withoutFooter: true
    }
  },
  {
    path: 'poland',
    name: 'employers-pl',
    component: EmployerPolandPage,
    meta: {
      withoutHeader: true,
    }
  },
  {
    path: 'services/legal/request-sent',
    name: 'legal-services-request-sent',
    component: LegalServicesHelpRequestSentPage
  },
  {
    path: 'find-vacancy-questionnaire',
    name: 'find-vacancy-questionnaire',
    component: FindVacancyQuestionnairePage
  },
  {
    path: 'find-vacancy',
    name: 'find-vacancy',
    component: FindVacancyPage
  },
  {
    path: 'response-additional-questions/:sentResumeId?',
    name: 'response-additional-questions',
    component: AdditionalQuestionsResponses
  },
  {
    path: 'for-employers',
    name: 'for-employers',
    component: EmployerPolandPage,
    meta: {
      withoutHeader: true,
    },
  },
  {
    path: 'city-lublin',
    name: 'city-lublin',
    component: LublinPage,
  },

  ...routesServices,

  ...routesPayment,

  ...routesStatic,

  {
    path: 'guide',
    name: 'guide',
    component: GuidePage
  }, {
    path: 'widget/test/1',
    name: 'widget-test1',
    component: WidgetTestPage1
  }, {
    path: 'widget/test/2',
    name: 'widget-test2',
    component: WidgetTestPage2
  }, {
    path: 'widget/test/3',
    name: 'widget-test3',
    component: WidgetTestPage3
  }, {
    path: 'widget/test/4',
    name: 'widget-test4',
    component: WidgetTestPage4
  }, {
    path: ':textSlug/:otherSlugs*',
    name: 'text-page',
    component: TextPage
  }, {
    path: '*',
    name: 'E404',
    component: E404
  }
]


// const routesAccount = () => import(/* webpackChunkName: "account-page" */ './routesAccount')
// const Account = () => import(/* webpackChunkName: "account-page" */ "../views/Account");
//
// const E404 = () => import(/* webpackChunkName: "e404-page" */ '../views/E404')
// const AuthPage = () => import(/* webpackChunkName: "auth-page" */ '../views/AuthPage')
// const HomePage = () => import(/* webpackChunkName: "home-page" */ '../views/HomePage')
// const VacanciesPage = () => import(/* webpackChunkName: "vacancies-page" */ '../views/VacanciesPage')
// const EmployerProfilePage = () => import(/* webpackChunkName: "employer-profile-page" */ "../views/EmployerProfilePage");
// const VacancyCardPage = () => import(/* webpackChunkName: "vacancy-card-page" */ "../views/VacancyCardPage");
// const TextPage = () => import(/* webpackChunkName: "text-page" */ "../views/TextPage");
//
// const NewsPage = () => import(/* webpackChunkName: "news-page" */ "../views/NewsPage");
// const NewsSinglePage = () => import(/* webpackChunkName: "news-page" */ "../views/NewsSinglePage");
//
// const CompanyProfilePage = () => import(/* webpackChunkName: "company-page" */ "../views/CompanyProfilePage");
// const SiteMap = () => import(/* webpackChunkName: "site-map-page" */ "../views/SiteMap");
// // const GuidePage = () => import(/* webpackChunkName: "guide-page" */ "../views/GuidePage");
// import {EMPLOYER, PARTNER, EMPLOYEE} from "../constants/usersTypes";

